// ======================================================================
// ERPReportLayout.jsx
// Standard ERP Report Container
// ======================================================================

import React from "react";
import "./reportStyles.css";

export default function ERPReportLayout({
  title,
  subtitle,
  toolbar,
  children,
}) {
  return (
    <div className="p-6 space-y-4">

      {/* ================= HEADER ================= */}
      <div>
        <h2 className="text-xl font-semibold text-gray-800">
          {title}
        </h2>

        {subtitle && (
          <p className="text-sm text-gray-500">
            {subtitle}
          </p>
        )}
      </div>

      {/* ================= TOOLBAR ================= */}
      {toolbar && (
        <div>
          {toolbar}
        </div>
      )}

      {/* ================= CONTENT ================= */}
      <div>
        {children}
      </div>

    </div>
  );
}
